<hfc-standalone-modal-container>
  <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <img
      [src]="tenantConfigService.desktopLogoUrl"
      [alt]="tenantConfigService.config.productName + ' logo'"
      role="img"
      [attr.aria-label]="tenantConfigService.config.productName + ' logo'"
      loading="lazy"
    />
    <div class="title">
      <i class="material-icons" routerLink="/login">arrow_back</i>
      {{ title }}
    </div>
    <p class="description">
      {{ description }}
    </p>

    <ng-container *ngIf="!done">
      <hfc-text-input type="email" placeholder="Email" autocomplete="email" formControlName="email"></hfc-text-input>

      <div *ngIf="message" class="error text-red">
        {{ message }}
      </div>

      <hfc-button
        type="primary"
        size="normal"
        [disabled]="form.invalid"
        [submit]="true"
        [isLoading]="isSubmitting"
      >Send Password Reset Link
      </hfc-button>
    </ng-container>
  </form>
</hfc-standalone-modal-container>
